<template>
	<main class="new-transportation">
		<section class="new-transportation__content">
			<div class="new-transportation__inner new-layout-container">
				<img
					class="new-transportation__icon"
					src="/static/buttons/new/transfer.svg"
					alt=""
					aria-hidden="true"
				>

				<div class="new-transportation__accent"></div>
				<h1>{{content.title}}</h1>
				<p class="new-transportation__lead">{{content.lead}}</p>

				<div class="new-transportation__items">
					<article
						v-for="item in content.items"
						:key="item.number"
						class="new-transportation__item"
					>
						<span class="new-transportation__number">{{item.number}}</span>
						<h2>{{item.title}}</h2>
						<p>{{item.text}}</p>
					</article>
				</div>
			</div>
		</section>
	</main>
</template>

<script>
import { translate } from '../../assets/translations';

export default {
	computed: {
		content() {
			return translate(this.$store.state.language).staticPages.transportation;
		},
	},
};
</script>

<style scoped lang="scss">
.new-transportation {
	background: #ffffff;
	color: #4c4b4b;
}

.new-transportation__content {
	padding: 83px 0 86px;
}

.new-transportation__inner {
	padding: 0;
}

.new-transportation__icon {
	display: block;
	width: 40px;
	height: 40px;
}

.new-transportation__accent {
	width: 44px;
	height: 4px;
	margin-top: 12px;
	margin-bottom: 18px;
	background: #5da3bd;
}

.new-transportation h1 {
	margin: 0 0 16px;
	color: #4c4b4b;
	font-size: 40px;
	font-weight: 500;
	line-height: 47px;
	letter-spacing: 0;
}

.new-transportation__lead {
	max-width: 1458px;
	margin: 0;
	color: #4c4b4b;
	font-size: 22px;
	font-weight: 400;
	line-height: 35px;
}

.new-transportation__items {
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 452px));
	justify-content: space-between;
	gap: 48px 42px;
	margin-top: 116px;
}

.new-transportation__item {
	min-width: 0;
	color: #4c4b4b;
}

.new-transportation__number {
	display: block;
	margin-bottom: 10px;
	color: #5da3bd;
	font-size: 80px;
	font-weight: 500;
	line-height: 94px;
}

.new-transportation__item h2 {
	min-height: 70px;
	margin: 0 0 20px;
	color: #4c4b4b;
	font-size: 25px;
	font-weight: 500;
	line-height: 35px;
	letter-spacing: 0;
}

.new-transportation__item p {
	margin: 0;
	color: #4c4b4b;
	font-size: 25px;
	font-weight: 400;
	line-height: 35px;
}

@media (max-width: 1180px) {
	.new-transportation__items {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
}

@media (max-width: 720px) {
	.new-transportation__content {
		padding: 58px 0 72px;
	}

	.new-transportation h1 {
		font-size: 34px;
		line-height: 40px;
	}

	.new-transportation__lead {
		font-size: 18px;
		line-height: 30px;
	}

	.new-transportation__items {
		grid-template-columns: 1fr;
		margin-top: 56px;
	}

	.new-transportation__item h2 {
		min-height: 0;
		margin-bottom: 18px;
	}

	.new-transportation__item p {
		font-size: 18px;
		line-height: 30px;
	}
}

@media (max-width: 420px) {
	.new-transportation__number {
		font-size: 62px;
		line-height: 72px;
	}

	.new-transportation__item h2 {
		font-size: 22px;
		line-height: 30px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/transportation/Transportation.vue